import {DatePipe} from '@angular/common';
export class MaskUtil {

    public static formatCnpj(value: string) {
        if (!value) {
            return '';
        }
        const cnpj = value.replace(/[^A-Za-z0-9]/g, '');
        return cnpj.replace(/([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})([A-Za-z0-9]{2})/g, '$1.$2.$3/$4-$5');
    }

  static dateToIsoStr(value: Date): string {
    if (!value) {
      return '';
    }
    return new DatePipe('pt-BR').transform(value, 'yyyy-MM-dd');
  }
}
